import type { NoteWithFiles } from "@msuite/utils/types";
import { RemoteFileInspector } from "../files";

/** Props Interface */
interface NoteFilesProps {
	note: NoteWithFiles;
	onCompleteEdit: () => void | Promise<void>;
}

export function NoteFiles({ note, onCompleteEdit }: NoteFilesProps) {
	/** Render */
	return (
		<div className="col-start-2">
			<RemoteFileInspector
				size="xs"
				itemFiles={note._files}
				variant="inline"
				tableName="noteFiles"
				foreignKey="noteId"
				identifier={note.id}
				parent={{ subject: "Note", resource: note }}
				withUpload
				onInteraction={onCompleteEdit}
				onLinked={onCompleteEdit}
			/>
		</div>
	);
}
